import { render, staticRenderFns } from "./mechanismStatistics.vue?vue&type=template&id=6e90ccc8&scoped=true"
import script from "./mechanismStatistics.vue?vue&type=script&lang=js"
export * from "./mechanismStatistics.vue?vue&type=script&lang=js"
import style0 from "./mechanismStatistics.vue?vue&type=style&index=0&id=6e90ccc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e90ccc8",
  null
  
)

export default component.exports